import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href", "innerHTML"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(((_ctx.isMobileActive && _ctx.isMobileActive !== null) ? _ctx.getClass('infoPanelMobile') : '') + ' ' +
    _ctx.getClass('infoPanel'))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('header'))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.getClass('title'))
      }, "Information", 2 /* CLASS */),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => (_ctx.hideInfo && _ctx.hideInfo(...args)), ["prevent"])),
        class: _normalizeClass(_ctx.getClass('close')),
        "aria-label": "Close Info",
        tabindex: "0"
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("svg", {
          width: "17",
          height: "17",
          xmlns: "http://www.w3.org/2000/svg",
          alt: "Close info"
        }, [
          _createElementVNode("path", {
            d: "M8.5 6.868l6.53-6.53a1.154 1.154 0 1 1 1.632 1.632l-6.53 6.53 6.53 6.53a1.154 1.154 0 1 1-1.632 1.632l-6.53-6.53-6.53 6.53A1.154 1.154 0 1 1 .338 15.03l6.53-6.53-6.53-6.53A1.154 1.154 0 1 1 1.97.338l6.53 6.53z",
            fill: "#D8D8D8",
            "fill-rule": "evenodd"
          })
        ], -1 /* HOISTED */)
      ]), 2 /* CLASS */)
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('infoPanelContent'))
    }, [
      _createElementVNode("ul", {
        class: _normalizeClass(_ctx.getClass('linkList'))
      }, [
        _createElementVNode("li", null, [
          _cache[2] || (_cache[2] = _createElementVNode("b", null, "Privacy & Legal Policies", -1 /* HOISTED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legalEntries, (rule) => {
            return (_openBlock(), _createElementBlock("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  rel: "noreferrer noopener",
                  href: rule.url,
                  innerHTML: rule.displayText,
                  target: "_blank"
                }, null, 8 /* PROPS */, _hoisted_1)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}